import Vue from 'vue';
import OwlDialog from '../components/common/OwlDialog.vue';
import { DIALOG_TYPE } from '../constants';

Vue.prototype.$dialog = {};

export default {
  components: {
    OwlDialog,
  },
  mounted() {
    let dialog = this.$refs.dialog;
    this.$dialog.info = (message, options = {}) => {
      return open(this.$t('cmmn.dialog.prompt'), message, Object.assign(options, { type: DIALOG_TYPE.ALERT }));
    };

    this.$dialog.alert = (message, options = {}) => {
      return open(this.$t('cmmn.dialog.alert'), message, Object.assign(options, { type: DIALOG_TYPE.ALERT }));
    };

    this.$dialog.confirm = (message, options = {}) => {
      return open(this.$t('cmmn.dialog.confirm'), message, Object.assign(options, { type: DIALOG_TYPE.CONFIRM }));
    };

    this.$dialog.prompt = (message, options = {}) => {
      return open(this.$t('cmmn.dialog.prompt'), message, Object.assign(options, { type: DIALOG_TYPE.PROMPT }));
    };

    function open(title, message, options) {
      return dialog.open(title, message, options);
    }
  },
};
